import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon, SmartphoneIcon, ZapIcon, RefreshCwIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="bg-navy text-white py-20 px-4" data-id="element-81">
      <div className="max-w-4xl mx-auto text-center" data-id="element-82">
        <h2 className="text-3xl md:text-5xl font-heading font-bold mb-6 leading-tight" data-id="element-83">
          Tu Futuro Financiero Comienza Hoy
        </h2>

        <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto" data-id="element-84">
          Cada mes que pasa sin construir crédito es tiempo perdido. Empieza
          ahora y aprende el sistema correcto para acercarte a un score de 700+.
        </p>

        <div id="precio" className="bg-white text-navy rounded-2xl p-8 md:p-12 shadow-2xl max-w-2xl mx-auto relative overflow-hidden" data-id="element-85">
          {/* Decorative badge */}
          <div className="absolute top-0 right-0 bg-green text-white font-bold py-1 px-8 transform translate-x-8 translate-y-4 rotate-45 shadow-md" data-id="element-86">
            OFERTA
          </div>

          <h3 className="text-2xl font-bold mb-6" data-id="element-87">
            Descarga "Crédito USA 700+"
          </h3>

          {/* Deliverables */}
          <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-8 mb-8 text-sm font-medium text-text-muted" data-id="element-88">
            <div className="flex items-center justify-center" data-id="element-89">
              <ZapIcon className="w-5 h-5 text-green mr-2" data-id="element-90" /> Acceso Inmediato
            </div>
            <div className="flex items-center justify-center" data-id="element-91">
              <SmartphoneIcon className="w-5 h-5 text-green mr-2" data-id="element-92" /> Ebook
              Digital (PDF)
            </div>
            <div className="flex items-center justify-center" data-id="element-93">
              <RefreshCwIcon className="w-5 h-5 text-green mr-2" data-id="element-94" />{' '}
              Actualizaciones
            </div>
          </div>

          <div className="flex flex-col items-center my-8 gap-2" data-id="element-95">
            <span className="text-4xl text-gray-400 line-through font-bold" data-id="element-96">
              $27 USD
            </span>
            <div className="bg-green-light border-2 border-green rounded-xl px-6 py-4 mt-2 w-full max-w-xs" data-id="element-97">
              <p className="text-sm font-semibold text-green-hover uppercase tracking-wider mb-1" data-id="element-98">
                Precio Especial Hoy
              </p>
              <span className="text-6xl md:text-7xl font-bold text-navy leading-none" data-id="element-99">
                $6.39{' '}
                <span className="text-2xl text-text-muted font-normal" data-id="element-100">
                  USD
                </span>
              </span>
            </div>
          </div>

          <div className="mb-8" data-id="element-101">
            <CTAButton text="DESCARGAR CRÉDITO USA 700+ AHORA" animate={true} href="https://realenlinea.com/cart/51230153605424:1" data-id="element-102" />
          </div>

          <div className="flex items-center justify-center text-sm text-text-muted mt-6 border-t border-gray-200 pt-6" data-id="element-103">
            <ShieldCheckIcon className="w-5 h-5 text-green mr-2" data-id="element-104" />
            <span data-id="element-105">Garantía de satisfacción. Pago 100% seguro.</span>
          </div>
        </div>
      </div>
    </section>;
}